import * as types from '@/store/mutation-types';
import log from '@/logger';

export const undo = async ({ commit, state, dispatch }) => {
  var undoBufferCursor = state.undoBufferCursor;

  if (undoBufferCursor === 0) {
    log.debug('undoActions::undo:nothing to undo');
    return;
  }

  log.info('undoActions::undo:attempting undo buffer', undoBufferCursor);
  for (var i = state.undoBuffer[undoBufferCursor].length - 1; i >= 0; i--) {
    var undoable = JSON.parse(state.undoBuffer[undoBufferCursor][i]);
    log.info('undoActions::undo:attempting undo buffer', [undoBufferCursor, 'action', undoable.action]);
    await dispatch('undo' + undoable.action.charAt(0).toUpperCase() + undoable.action.slice(1), undoable.data);
  }
  await commit(types.undo);
  log.info('undoActions::undo:done undoing buffer', [undoBufferCursor]);
};

export const redo = async ({ commit, state, dispatch }) => {
  if (!state.undoBuffer[state.undoBufferCursor + 1]) {
    return;
  }

  log.debug('undoActions::redo:attempting redo buffer', [
    state.undoBufferCursor + 1,
    state.undoBuffer[state.undoBufferCursor + 1],
  ]);
  for (var i = 0; i < state.undoBuffer[state.undoBufferCursor + 1].length; i++) {
    var undoable = JSON.parse(state.undoBuffer[state.undoBufferCursor + 1][i]);
    log.info('undoActions::redo:attempting redo buffer', [state.undoBufferCursor + 1, 'action', undoable.action]);
    await dispatch('redo' + undoable.action.charAt(0).toUpperCase() + undoable.action.slice(1), undoable.data);
  }

  await commit(types.redo);
};

export const clearUndo = async ({ commit, state, dispatch }) => {
  return commit(types.clearUndo);
};



// WEBPACK FOOTER //
// ./src/store/undo/undoActions.js